<div mat-dialog-content>{{message}}</div>
<div>
    <mat-form-field>
        <input matInput [(ngModel)]="inputValue" [placeholder]="inputPlaceholder">
    </mat-form-field>
</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-warn mr-16" (click)="dialogRef.close(inputValue)">Zapisz</button>
    <button mat-button (click)="dialogRef.close()">Anuluj</button>
</div>